import { OsCard, OsCardMedia, OsGrid, Typography } from "@outschool/backpack";
import { useIsMobile } from "@outschool/ui-utils";
import React from "react";

import bearImage from "./avatar-animals/bear.png";
import dragonImage from "./avatar-animals/dragon.png";
import eagleImage from "./avatar-animals/eagle.png";
import elephantImage from "./avatar-animals/elephant.png";
import lionImage from "./avatar-animals/lion.png";
import octopusImage from "./avatar-animals/octopus.png";
import sharkImage from "./avatar-animals/shark.png";
import tigerImage from "./avatar-animals/tiger.png";
import unicornImage from "./avatar-animals/unicorn.png";
import wolfImage from "./avatar-animals/wolf.png";

interface Animal {
  name: string;
  imageUrl: string;
}

const AVAILABLE_ANIMALS: Animal[] = [
  { name: "Lion", imageUrl: lionImage },
  { name: "Eagle", imageUrl: eagleImage },
  { name: "Shark", imageUrl: sharkImage },
  { name: "Elephant", imageUrl: elephantImage },
  { name: "Tiger", imageUrl: tigerImage },
  { name: "Bear", imageUrl: bearImage },
  { name: "Wolf", imageUrl: wolfImage },
  { name: "Octopus", imageUrl: octopusImage },
  { name: "Dragon", imageUrl: dragonImage },
  { name: "Unicorn", imageUrl: unicornImage },
];

interface AnimalSelectionGridProps {
  selectedAnimals: string[];
  onAnimalToggle: (animalName: string) => void;
}

export default function AnimalSelectionGrid({
  selectedAnimals,
  onAnimalToggle,
}: AnimalSelectionGridProps) {
  const isMobile = useIsMobile();
  return (
    <OsGrid container spacing={4}>
      {AVAILABLE_ANIMALS.map(animal => {
        const isSelected = selectedAnimals.includes(animal.name);
        return (
          <OsGrid
            xs={6}
            md={2.4}
            key={animal.name}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: { xs: 2, md: 4 },
            }}
          >
            <OsCard
              onClick={() => onAnimalToggle(animal.name)}
              selected={isSelected}
              padding={0}
            >
              <OsCardMedia
                image={animal.imageUrl}
                alt={animal.name}
                height={isMobile ? 140 : 160}
                width={isMobile ? 140 : 160}
              />
            </OsCard>
            <Typography variant="body2">{animal.name}</Typography>
          </OsGrid>
        );
      })}
    </OsGrid>
  );
}
